import React, { useState } from 'react';
import styled from 'styled-components';

// Styled components for the Contact page
const ContactContainer = styled.div`
  padding: 40px 20px;
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
`;

const Title = styled.h2`
  font-size: 2.5rem;
  color: #2c3e50;
  margin-bottom: 20px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const Label = styled.label`
  font-size: 1rem;
  color: #2c3e50;
  text-align: left;
`;

const Input = styled.input`
  padding: 10px;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 5px;
  transition: border-color 0.3s ease;

  &:focus {
    border-color: #2089ac;
    outline: none;
  }
`;

const TextArea = styled.textarea`
  padding: 10px;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 5px;
  resize: vertical;
  min-height: 150px;
  transition: border-color 0.3s ease;

  &:focus {
    border-color: #2089ac;
    outline: none;
  }
`;

const SubmitButton = styled.button`
  background-color: #2089ac;
  color: white;
  padding: 15px 30px;
  font-size: 1.2rem;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #1a6f8b;
  }
`;

const Contact = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    // Target WhatsApp number
    const phoneNumber = '+212661497628';

    // Create the WhatsApp message
    const whatsappMessage = `Bonjour, je souhaite vous contacter. Voici les détails:\n\n` +
      `Nom: ${name}\n` +
      `Email: ${email}\n` +
      `Téléphone: ${phone}\n` +
      `Message: ${message}`;

    // Encode the message for the URL
    const encodedMessage = encodeURIComponent(whatsappMessage);

    // Open WhatsApp with the pre-filled message
    window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, '_blank');

    // Reset the form
    setName('');
    setEmail('');
    setPhone('');
    setMessage('');
  };

  return (
    <ContactContainer>
      <Title>Contactez-nous</Title>
      <Form onSubmit={handleSubmit}>
        <Label>Nom:</Label>
        <Input
          type="text"
          name="name"
          placeholder="Votre nom"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />

        <Label>Email:</Label>
        <Input
          type="email"
          name="email"
          placeholder="Votre email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <Label>Téléphone:</Label>
        <Input
          type="tel"
          name="phone"
          placeholder="Votre téléphone"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          required
        />

        <Label>Message:</Label>
        <TextArea
          name="message"
          placeholder="Votre message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          required
        />

        <SubmitButton type="submit">Envoyer via WhatsApp</SubmitButton>
      </Form>
    </ContactContainer>
  );
};

export default Contact;